import React from 'react';
import type { TalentNode } from '../../../../shared/CharacterTypes';
import { TomeButton, TomeChip, TomeEntry } from '../../primitives/tome';
import { TALENT_TONE, talentEffectLabel, talentIcon, type TalentState } from './talentPresentation';

/** One talent on the page. Its ranks are the owner snapshot's; the button only asks. */
export const TalentEntry: React.FC<{
  node: TalentNode; state: TalentState; pending: boolean; busy: boolean; prerequisiteNames: string[]; onSpend: () => void;
}> = ({ node, state, pending, busy, prerequisiteNames, onSpend }) => {
  const canSpend = state === 'ready' && !busy;
  const label = pending ? 'Saving…' : busy ? 'Waiting…' : state === 'mastered' ? 'Max Rank' : state === 'locked' ? 'Locked'
    : state === 'ready' ? 'Allocate' : `Need ${node.cost} pt${node.cost !== 1 ? 's' : ''}`;
  const icon = talentIcon(node);
  const effects = node.effects.map(talentEffectLabel).join(' · ');
  return <TomeEntry className="talents-tome__entry" tone={TALENT_TONE[state]} shapeSeed={node.id} density="compact"
    data-testid={`talent-node-${node.id}`} data-talent-state={state}
    title={<span className="talents-tome__title">
      <span className="talents-tome__art" aria-hidden="true">
        {icon.startsWith('/') ? <img src={icon} alt="" width={34} height={34} /> : icon}
      </span>
      <span>{node.name}</span>
    </span>}
    status={<TomeChip tone={TALENT_TONE[state]} cut="clean">Rank {node.currentRank}/{node.maxRank}</TomeChip>}>
    <p className="talents-tome__description">{node.description}</p>
    {effects && <p className="talents-tome__effects" data-testid={`talent-effects-${node.id}`}>{effects}</p>}
    {prerequisiteNames.length > 0 && <p className="talents-tome__requires" data-requirement-status={state === 'locked' ? 'unmet' : 'met'}>
      Requires {prerequisiteNames.join(', ')}</p>}
    <footer className="talents-tome__entry-foot">
      <span>{node.cost} talent point{node.cost !== 1 ? 's' : ''}</span>
      <TomeButton tone={canSpend ? 'primary' : 'secondary'} cut="clean" disabled={!canSpend} onClick={onSpend}
        data-testid={`talent-spend-${node.id}`}>{label}</TomeButton>
    </footer>
  </TomeEntry>;
};
